// client/src/features/fiscal/enums.ts — the fiscal wire enums, as runtime lists · FISC-007.
//
// The generated client gives every enum as a string-literal UNION, and a union has no runtime
// value: a `<select>` cannot iterate it and `z.enum()` cannot validate a search param against
// it. So each set is spelled out once here and HELD to the union with `Record<T, true>`, which
// is exhaustive in both directions — a member the contract adds and this file lacks, or one
// this file keeps after the contract drops it, fails `tsc` in the PR that regenerated the
// client. `features/rent/enums.ts` is the shape this copies.
//
// The names are also the `enums.{EnumName}.{VALUE}` keys `StatusBadge` renders through §9.6.3's
// one sanctioned computed key, which is why they must be held to the contract rather than typed
// out freely: a name that drifts renders its own key path.

import type { ObligationStatus, SubmissionChannel } from '@/client';

const OBLIGATION_STATUS_ORDER: Record<ObligationStatus, true> = {
  REQUIRED: true,
  NEEDS_VERIFICATION: true,
  NOT_REQUIRED: true,
};

/**
 * Ordered by how much they ask of the reader, not alphabetically: „Este necesară" first,
 * because SCR-FISC-001 is the Q5 screen and the row that costs money if ignored is the one a
 * filter is reached for.
 */
export const OBLIGATION_STATUSES = Object.keys(
  OBLIGATION_STATUS_ORDER,
) as readonly ObligationStatus[];

const SUBMISSION_CHANNEL_ORDER: Record<SubmissionChannel, true> = {
  SPV_WEB: true,
  EGUV_UPLOAD: true,
  DESK: true,
  POST: true,
  API: true,
};

/**
 * The channels a landlord can actually pick on SCR-FISC-005.
 *
 * `API` is a member of the contract and is NOT offered: the server refuses it with a 422
 * because there is no API to have filed through (`RecordSubmissionRequest`'s own doc comment),
 * and V2's SubmissionAssist is what earns it. Offering a value the server always refuses is a
 * form that teaches the user nothing.
 */
export const SUBMISSION_CHANNELS = (
  Object.keys(SUBMISSION_CHANNEL_ORDER) as readonly SubmissionChannel[]
).filter((channel) => channel !== 'API');
